import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import BarleyProduct from 'models/BarleyProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotNumericDecimal } from 'context/Utilities'

const BarleyPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        GrainSize,
        BarleyVerification,
        Organic,
      } = current
      setPackaging({
        category,
        subCategory,
        GrainSize,
        BarleyVerification,
        Organic,
      })
    } else if (!updating) {
      setCurrent(BarleyProduct)
    }
    // eslint-disable-next-line
    }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'12 - 48 ounces'}
            control={methods.control}
            rules={{
              validate: GrainSize => GrainSize >= 12 && GrainSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="GrainSize"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            I certify that this is a whole grain barley product and is not
            pearled barley. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="BarleyVerification"
          id="BarleyVerification"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.BarleyVerification}
          rules={{
            validate: BarleyVerification => BarleyVerification === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BarleyVerification"
            message={'⚠ Product must be barley.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.Organic}
        />
      </Col>
    </Row>
  )
}

export default BarleyPackage
